import { get } from 'lodash'

import {
  GET_SALES_EVENTS_REQUESTED,
  GET_SALES_EVENTS_SUCCEEDED,
  GET_SALES_EVENTS_FAILED,
  UPDATE_FILTER,
  UPDATE_SALES_EVENT_SUCCEEDED,
} from './constants'
import DataMapper from '../../utils/dataMapper'

export const defaultState = {
  byId: {},
  filter: {
    showPreviousEvents: true,
  }
}

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case GET_SALES_EVENTS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case GET_SALES_EVENTS_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId,
        isLoading: false,
      }
    }

    case GET_SALES_EVENTS_FAILED: {
      return {
        ...state,
        isLoading: false
      }
    }

    case UPDATE_FILTER: {
      const key = get(payload, 'key', '')
      const value = get(payload, 'value', '')

      return {
        ...state,
        filter: {
          ...state.filter,
          [key]: value
        }
      }
    }

    case UPDATE_SALES_EVENT_SUCCEEDED:
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId
        }
      }

    default:
      return state
  }
}
